import { render, staticRenderFns } from "./DiagnosticLatestTable.vue?vue&type=template&id=66b76652&scoped=true"
import script from "./DiagnosticLatestTable.vue?vue&type=script&lang=js"
export * from "./DiagnosticLatestTable.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticLatestTable.vue?vue&type=style&index=0&id=66b76652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b76652",
  null
  
)

export default component.exports